export var PayedFeatureType;
(function (PayedFeatureType) {
    PayedFeatureType["NONE"] = "NONE";
    PayedFeatureType["THERAME"] = "THERAME";
})(PayedFeatureType || (PayedFeatureType = {}));
//# sourceMappingURL=payment-feature-type.enum.js.map